import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { Loader } from "@vds/loaders";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSearchParams, Link, useLocation, useNavigate } from "react-router-dom";
import { setCameraCaliration } from "../../api/RoiServiceManager";
import {
  BackAndNextButtonsContainer,
  FrameForDataContainer,
} from "../../global/components/OnboardingFormStyles/Styles";
import { showCalibrationBanner, refreshCameraPage, updateCameraCalibrationStatus } from "../../store/actions";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";
import ManualCalibration from "./manualCalibration";


const StreamManualCalibration = () => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const { state } = useLocation();
  const [farposition, setFarPosition] = useState([]);
  const [nearSize, setNearSize] = useState([]);
  const [farSize, setFarSize] = useState([]);
  const [manualCount, setmanualCount] = useState(0);
  const [manualDevices, setManualDevices] = useState([]);
  const [selectdeviceId, setSelectDeviceId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isManual, setIsManual] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cameraData = state?.data;
  const handleBack = () => {
    navigate(`/cameraInfoPage?cameraId=${state?.cameraId}`);
  };
  const handleButtonClick = async () => {
    let config;
    let deviceid = state?.fovDetails?.id;
    setIsLoading(true);
    const farpositionM = farposition.filter((f) => f.id === deviceid);
    const farSizeM = farSize.filter((f) => f.id === deviceid);
    const nearSizeM = nearSize.filter((f) => f.id === deviceid);
    config = {
      farposition: farpositionM[0]?.farposition
        ? farpositionM[0]?.farposition
        : 100,
      sceneparameters: {
        far_size: farSizeM[0]?.farSize ? farSizeM[0]?.farSize : 1,
        near_size: nearSizeM[0]?.nearSize ? nearSizeM[0]?.nearSize : 1,
      },
    };

    let payload = {
      accountname: activeSession?.accountId,
      resources: [
        {
          fovidentifier: {
            deviceid: deviceid,
          },
          config,
        },
      ],
    };
    const res = await setCameraCaliration(payload, activeSession);
    if (res == 200 || res == 202) {
      dispatch(updateCameraCalibrationStatus(true));
      dispatch(refreshCameraPage(true));
      navigate(`/cameraInfoPage?cameraId=${state?.cameraId}`);
    } else {
      const notificationInfo = {
        type: "Calibration Fail",
        priority: "critical",
        showNotification: true,
      };
      dispatch(showCalibrationBanner(notificationInfo));
    }
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <Loader fullscreen={true} active={isLoading} disableFocusLock />}
      <Breadcrumbs surface="light">
        <BreadcrumbItem>
          <Link
            data-testid="cameraOnboarding_discoveredCamerasDevicesLink"
            to="/devices"
            className="breadcrums-item_link"
          >
            Cameras
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link
            data-testid="cameraOnboarding_cameraInfoPageLink"
            to={{
                  pathname: "/cameraInfoPage",
                  search: `?${createSearchParams({
                    cameraId: state?.cameraId,
                  })}`,
                }}
            state={{ data: state?.cameraId ? state?.cameraId : {} }}
            className="breadcrums-item_link"
          >
            Camera Details
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>Manual calibration</BreadcrumbItem>
      </Breadcrumbs>
      <br></br>
      {/* <div className="w-50">
        <Title size="medium">Manual Calibration</Title>
      </div> */}
      <FrameForDataContainer
        className={`d-flex justify-content-center align-items-center w-100`}
      >
        <ManualCalibration
          setFarPosition={setFarPosition}
          farposition={farposition}
          deviceid={state?.selectdeviceId}
          farSize={farSize}
          setFarSize={setFarSize}
          nearSize={nearSize}
          setNearSize={setNearSize}
          imageUrl={state?.streamImage}
          selectName={state?.fieldOfViews}
          existingCalibrationConfig={state?.data?.customdata?.calibrationConfig}
        />
        <BackAndNextButtonsContainer>
          <Button
            onClick={() => {
              handleBack();
            }}
            data-testid={CAMERA_ONBOARDING_TEST_IDS.MANUAL_CALIBRATION_BACK_BUTTON}
            size="large"
            use="primary"
          >
            Back
          </Button>
          <Button
            onClick={() => {
              handleButtonClick();
            }}
            data-testid={CAMERA_ONBOARDING_TEST_IDS.MANUAL_CALIBRATION_SUBMIT_BUTTON}
            size="large"
            use="primary"
          >
            Submit
          </Button>
        </BackAndNextButtonsContainer>
      </FrameForDataContainer>
    </>
  );
};

export default StreamManualCalibration;
